/**
 * Store global de mes seleccionado — Zustand minimalista.
 */
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface MonthState {
  selectedMonthId: string | null;
  setSelectedMonthId: (id: string | null) => void;
}

export const useMonthStore = create<MonthState>()(
  persist(
    (set) => ({
      selectedMonthId: null,
      setSelectedMonthId: (id) => set({ selectedMonthId: id }),
    }),
    { name: 'chef-analist-month' },
  ),
);
